import React from 'react';
import { useFirebaseStore } from '../store/Firebase';
import { RemoteConfigKeys } from '../utils/enums/remote-config';

export const useRemoteConfig = () => {
  const { remoteConfigValues } = useFirebaseStore();

  return { getRemoteConfigValue: (key: keyof typeof RemoteConfigKeys) => remoteConfigValues?.[key]?._value };
};
